export default __webpack_public_path__ + "img/b3b5773cfeb1138309ae81ccaed984b2.svg";